export const timePeriodOptions = [
  {
    value: 'HOUR',
    label: 'datagate.external.global.obligation.timePeriod.hour',
  },
  { value: 'DAY', label: 'datagate.external.global.obligation.timePeriod.day' },
  {
    value: 'WEEK',
    label: 'datagate.external.global.obligation.timePeriod.week',
  },
  {
    value: 'MONTH',
    label: 'datagate.external.global.obligation.timePeriod.month',
  },
  {
    value: 'YEAR',
    label: 'datagate.external.global.obligation.timePeriod.year',
  },
];

export const periodTypes = {
  UNLIMITED: 'datagate.external.global.obligation.periodType.unlimited',
  LIMITED: 'datagate.external.global.obligation.periodType.limited',
  SINGLE: 'datagate.external.global.obligation.periodType.single',
};

export const mapPeriodTypeToText = type => periodTypes[type] || '';

export const DeadlineOption = {
  NONE:'NONE',
  PREVIOUS:'PREVIOUS',
  FOLLOWING:'FOLLOWING'
}
